import { useI18n } from 'vue-i18n';

const en = {
  CONTACT_DETAIL: {
    CHOOSE_CONNECTION: 'WHICH CONNECTION?',
    MOST_RECENT: 'Most recent',
    CONNECTION_LAST_MESSAGE: 'Last message {date}',
    NO_CONVERSATION_YET: 'No conversation yet · starts a new one',
    NO_MESSAGES_YET: 'No messages yet',
    START_CONVERSATION: '+ Start conversation',
    CONVERSATION_ERROR: 'Could not start the conversation. Please try again.',
    OWNER: 'Lead owner',
    NO_OWNER: 'No owner',
    OWNER_LOAD_ERROR: 'Could not load lead owners.',
    OWNER_ERROR: 'Could not change the lead owner.',
    OWNER_SUCCESS: 'Lead owner updated.',
    OWNER_SKIPPED: 'This contact cannot be assigned to a lead owner.',
    ALL: 'All',
    OPEN: 'Open',
    RESOLVED: 'Resolved',
    OPEN_STATUS: 'Open',
    RESOLVED_STATUS: 'Resolved',
    CONVERSATION: 'Conversation',
    PRIORITY: 'Priority',
    STATUS: 'Status',
    ASSIGNEE: 'Agent',
    NO_ASSIGNEE: 'No agent',
    LAST_MESSAGE: 'Last message',
    MEDIA: 'Media received',
    NOTES_PLACEHOLDER:
      'Write a note about this contact… (only your team can see it)',
    NOTES_PRIVATE: 'Notes are internal: the customer cannot see them.',
    EDIT_NOTE: 'Edit',
    DELETE: 'Delete',
    CANCEL: 'Cancel',
    SAVE: 'Save',
    EDITED: '(edited)',
    DELETE_CONFIRM: 'Delete this note?',
    NOTE_DELETED: 'Note deleted',
    NOTES_EMPTY:
      'No notes yet. Use the field above to record something about this contact.',
    DELETE_NOTE: 'Delete note',
    NOTE_ERROR: 'Could not save the note. Please try again.',
    NOTE_DELETE_ERROR: 'Could not delete the note. Please try again.',
  },
};
const pt = {
  CONTACT_DETAIL: {
    CHOOSE_CONNECTION: 'FALAR POR QUAL CONEXÃO?',
    MOST_RECENT: 'Mais recente',
    CONNECTION_LAST_MESSAGE: 'Última mensagem {date}',
    NO_CONVERSATION_YET: 'Sem conversa ainda · inicia uma nova',
    NO_MESSAGES_YET: 'Sem mensagens ainda',
    START_CONVERSATION: '+ Iniciar conversa',
    CONVERSATION_ERROR: 'Não foi possível iniciar a conversa. Tente novamente.',
    OWNER: 'Responsável pelo lead',
    NO_OWNER: 'Sem responsável',
    OWNER_LOAD_ERROR: 'Não foi possível carregar os responsáveis.',
    OWNER_ERROR: 'Não foi possível alterar o responsável pelo lead.',
    OWNER_SUCCESS: 'Responsável pelo lead atualizado.',
    OWNER_SKIPPED:
      'Este contato não permite atribuição de responsável pelo lead.',
    ALL: 'Todas',
    OPEN: 'Abertas',
    RESOLVED: 'Resolvidas',
    OPEN_STATUS: 'Aberta',
    RESOLVED_STATUS: 'Resolvida',
    CONVERSATION: 'Conversa',
    PRIORITY: 'Prioridade',
    STATUS: 'Status',
    ASSIGNEE: 'Atendente',
    NO_ASSIGNEE: 'Sem atendente',
    LAST_MESSAGE: 'Última mensagem',
    MEDIA: 'Mídia recebida',
    NOTES_PLACEHOLDER: 'Escreva uma nota sobre este contato… (só a equipe vê)',
    NOTES_PRIVATE: 'Notas são internas: o cliente não vê.',
    EDIT_NOTE: 'Editar',
    DELETE: 'Excluir',
    CANCEL: 'Cancelar',
    SAVE: 'Salvar',
    EDITED: '(editada)',
    DELETE_CONFIRM: 'Excluir esta nota?',
    NOTE_DELETED: 'Nota excluída',
    NOTES_EMPTY:
      'Nenhuma nota ainda. Use o campo acima para registrar algo sobre este contato.',
    DELETE_NOTE: 'Excluir nota',
    NOTE_ERROR: 'Não foi possível salvar a nota. Tente novamente.',
    NOTE_DELETE_ERROR: 'Não foi possível excluir a nota. Tente novamente.',
  },
};

export const useContactDetailI18n = () =>
  useI18n({ useScope: 'local', messages: { en, pt, pt_BR: pt, 'pt-BR': pt } });
